import { render, staticRenderFns } from "./EndorsementTypeTable.vue?vue&type=template&id=0cd80b6a"
import script from "./EndorsementTypeTable.vue?vue&type=script&lang=ts"
export * from "./EndorsementTypeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports